export namespace IParksConfigResource {
  export enum Action {
    ParksMake = 'Parks_MK',
  }

  export enum Command {
    Get = 'get',
  }
}